import React, { useEffect, useContext } from 'react';

import PurchaseDetails from './PurchaseDetails';
import BillingDetails from './billingDetails/billingDetails';

import { CONTEXT } from 'home/view/upgrade-order/context';

import { getLeadStatus } from 'home/view/upgrade-order/utils';

import './index.scss';
import { isFormTouched } from 'common/utils/app.utils';

export const keyForGSTFiles = {
  GST_CERTIFICATE: 'filesForGSTCerificate',
  GST_LOA: 'filesForGSTLOA'
};

function DedicatedOrderSummary(props) {
  const { orderDetail, isOrderLoaded, setFormStatus, setFormData, updateOrder, leadData, showBillingDetails } = props;
  const { setToastMsg } = useContext(CONTEXT);

  const updateParentForm = (updatedForm) => {
    setFormData((prevState) => {
      return { ...prevState, ...updatedForm };
    });
  };

  const updateFormStatus = (formStatus) => {
    setFormStatus((prevState) => {
      return { ...prevState, ...formStatus };
    });
  };

  return (
    <section className="order_summary_form">
      <div className="row">
        <div className="flg-lg-12 flg-md-12">
          {isOrderLoaded && (
            <React.Fragment>
              <PurchaseDetails
                order={orderDetail}
                updateParentForm={updateParentForm}
                setFormStatus={updateFormStatus}
                updateOrder={updateOrder}
                setToast={setToastMsg}
                leadStatus={getLeadStatus(leadData)}
                {...props}
              />

              {showBillingDetails && (
                <BillingDetails order={orderDetail} updateParentForm={updateParentForm} setFormStatus={updateFormStatus} leadStatus={getLeadStatus(leadData)} {...props} />
              )}
            </React.Fragment>
          )}
        </div>
      </div>
    </section>
  );
}
export default DedicatedOrderSummary;
